<template>
    <v-app>
        <v-container>
            <v-row>
                <h3>Roles</h3>
            </v-row>
            <v-row class="mt-5">
                <v-btn color="default" @click="$router.push('/role/create')">Agregar Rol</v-btn>
            </v-row>
            <v-row class="mt-5 bold">
            <v-col lg="2">
                ID
            </v-col>
            <v-col lg="2">
                Nombre
            </v-col>

            <v-col lg="2">
                ...
            </v-col>
            </v-row>
            <v-row  v-for="user in users" :key="user.id">
                <v-col lg="2">{{user.id}}</v-col>
                <v-col lg="2">{{user.name}}</v-col>

                <v-col lg="2">
                    <v-btn color="info" @click="$router.push(`/role/${user.id}`)">Ver</v-btn>
                </v-col>
            </v-row>
        </v-container>
        
    </v-app>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return {
            users: []
        }
    },
    methods: {
        getData: async function(){
            let {data} = await axios.get('https://127.0.0.1:3000/role/')
            this.users=data
        }
    },
    mounted(){
        this.getData()
    }
}
</script>

<style>
    .bold{
        font-weight: bolder
    }
</style>